import ky from 'ky';

import { env } from '@/env';

import type { ApiHTTPError, ProblemDetails } from './client';

// API client for the ANONYMOUS applicant flow (public share link). Deliberately
// carries NO auth token, NO tenant header, and NO 401-refresh/logout hooks — the
// applicant is not logged in, and the backend authorizes purely by the public
// token in the URL. Only the ProblemDetails-parsing hook is shared.
export const publicApiClient = ky.create({
  prefixUrl: env.VITE_API_BASE_URL,
  timeout: 30_000,
  retry: { limit: 1 },
  hooks: {
    beforeError: [
      async (error: ApiHTTPError) => {
        try {
          const body = (await error.response.clone().json()) as ProblemDetails;
          error.data = body;
        } catch {
          // Non-JSON error body — leave error.data undefined.
        }
        return error;
      },
    ],
  },
});
